import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateDataSearchTaiKhoanIcloud } from "../../../actions/QuanTriHeThong";
export const SearchBarMobile = ({ onSearch }) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchTaiKhoanIcloud);

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateState = (field, text) => {
    dispatch(
      updateDataSearchTaiKhoanIcloud({
        ...dataSearch,
        [field]: text,
      })
    );
  };
  const updateDropdown = (field) => (e) => {
    updateState(field, e.target.value);
  };
  const SoHDLienKet = {
    lstSoHDLienKet: [
      {
        label: "Số HĐ liên kết",
        value: "-1",
      },
      { label: "0", value: "0" },
      { label: "1", value: "1" },
      { label: "2", value: "2" },
      { label: "3", value: "3" },
      { label: "4", value: "4" },
      { label: "5", value: "5" },
      { label: ">5", value: "6" },
    ],
  };
  return (
    <>
      <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
        <div data-repeater-list="car">
          <div data-repeater-item className="">
            <form className="search-full form row bg-search-form form-mobile-search">
              <div className="text-right left-search search-p mb-1 ">
                <div className="search-mobile-new">
                  <fieldset className="form-group position-relative mb-0">
                    <select
                      name="loaigiaodich"
                      className="selectBox form-control input-sm"
                      value={dataSearch.SoHDLienKet}
                      onChange={updateDropdown("SoHDLienKet")}
                    >
                      {SoHDLienKet.lstSoHDLienKet &&
                        SoHDLienKet.lstSoHDLienKet.map((item, idx) => (
                          <option
                            key={"objComboStore1" + idx}
                            value={item.value}
                          >
                            {item.label}
                          </option>
                        ))}
                    </select>
                  </fieldset>
                </div>
              </div>
              <div className="text-right left-search search-p mb-1 ">
                <div className="search-mobile-new">
                  <fieldset className="form-group position-relative mb-0">
                    <input
                      type="text"
                      className="form-control input-sm"
                      id="iconLeft1"
                      placeholder="Tên tài khoản"
                      value={dataSearch.TenTaiKhoan}
                      onChange={updateTextValue("TenTaiKhoan")}
                    />
                  </fieldset>
                </div>
              </div>
              <div className="text-right left-search search-p mb-1 ">
                <div className="search-mobile-new">
                  <fieldset className="form-group position-relative mb-0">
                    <input
                      type="text"
                      className="form-control input-sm"
                      id="iconLeft1"
                      placeholder="Số điện thoại"
                      value={dataSearch.SoDienThoai}
                      onChange={updateTextValue("SoDienThoai")}
                    />
                    <div className="form-control-position">
                      <button
                        type="button"
                        onClick={onSearch}
                        className="btn btn-info-new"
                      >
                        <i className="mdi mdi-magnify"></i>
                      </button>
                    </div>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
